<script setup>
  import { computed } from 'vue'
  import MapButtonSidebarPinnedMap from "@/components/MapButtonSidebarPinnedMap.vue";
  import Icon from "@/components/icons/Icon.vue";
  import { useMapUIStore } from '@/stores/MapUIStore';
  import { useProductStore } from '@/stores/ProductStore';

  const mapUIStore = useMapUIStore();
  const productStore = useProductStore();

  await productStore.getRegionalProducts(true);

  const showPinnedMap = computed(() => {
    return mapUIStore.pinnedMaps.length > 0 && mapUIStore.showPinnedMapBar;
  })

  const pinnedMapList = computed(() => productStore.allProductsList.filter(product => mapUIStore.pinnedMaps.includes(product.id)));  
</script>

<template>
  <div v-if="showPinnedMap" class="sidebar__secondary jwx-map-block jwx-map-block--transparent-border jwx-map-block--column">
    <ul class="jwx-map-block__content jwx-map-block__items">
      <li v-for="pinnedMap in pinnedMapList" class="jwx-map-block__item" :key="pinnedMap.id">
        <MapButtonSidebarPinnedMap :product="pinnedMap">
          <Icon class="jwx-map-button__icon" :name="pinnedMap.overlayName" />
        </MapButtonSidebarPinnedMap>
      </li>
    </ul>
  </div>    
</template>